import { useState } from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Avatar({ name, email, selectable, image, size }) {
  const [hover, setHover] = useState(false);
  const [selected, setSelected] = useState(false);
  return (
    <div
      onMouseEnter={() => selectable && setHover(true)}
      onMouseLeave={() => selectable && setHover(false)}
      className={`w-${size || 8} h-${size || 8}  text-center ${
        image ? "" : "bg-gray-200 rounded-full overflow-hidden"
      } flex items-center justify-center`}
    >
      {hover || selected ? (
        <input
          id="comments"
          onClick={(e) => {
            if (selectable) {
              e.stopPropagation();
              setSelected(!selected);
            }
          }}
          aria-describedby="comments-description"
          name="comments"
          type="checkbox"
          className={`h-${(size && size - 1) || 6} w-${
            (size && size - 1) || 8
          } rounded border-gray-300 text-xs text-gray-800 cursor-pointer border-2 focus:ring-gray-200`}
        />
      ) : image ? (
        <img
          style={{ objectFit: "contain" }}
          src={image}
          alt={name}
          className="w-full h-full"
        />
      ) : (
        <p
          className="font-semibold text-gray-600"
          style={{ fontSize: size ? size * 2 : 12 }}
        >
          {(name || email)?.slice(0, 1).toUpperCase()}
        </p>
      )}
    </div>
  );
}
